import { combineReducers } from "redux";

import {
    CONTACT_UPDATED,
    DIALER_CALL_UPDATED,
    DEAL_CREATE_LOADING,
    DEAL_CREATED,
    DEBT_ACTIONS_LOADING,
    DEBT_ACTIONS_LOADED,
    DEBT_ACTIONS_CLEAR,
    OPERATOR_ACTION_CREATED,
    CALL_FINISHED,
    OPERATOR_LOAD_DEBTORS_REQUEST,
    OPERATOR_LOAD_DEBTORS_SUCCESS,
    OPERATOR_LOAD_DEBTORS_ERROR,
    OPERATOR_LOAD_DEBT_SIMULATION_REQUEST,
    OPERATOR_LOAD_DEBT_SIMULATION_SUCCESS,
    OPERATOR_LOAD_DEBT_SIMULATION_ERROR,
    SEND_TEXT_SUCCESS,
    SEND_TEXT_ERROR,
    OPERATORS_LOAD_SUCCESS,
    OPERATOR_PHONE_CREATED,
    OPERATOR_PHONE_UPDATED,
    OPERATOR_EMAIL_CREATED,
    OPERATOR_EMAIL_UPDATED,
    OPERATOR_HYGIENIZED_DEBTOR,
    OPERATOR_DIAL_TIMER_CHANGED,
    DIALER_CALL_ENDED,
    SET_VOIP_CAMPAIGN,
} from "modules/operators/actions/operator.action";

import {
    LOAD_REQUEST_ERROR,
    LOAD_REQUEST_REQUEST,
    LOAD_REQUEST_SUCCESS
} from "modules/requests/actions/request.actions";

import { AUTH_LOGOUT } from "modules/auth/actions/authentication.action";

import { VOIP_CAMPAIGNS } from '../constants';

export const contact = (state = null, action) => {
    switch (action.type) {
        case CONTACT_UPDATED:
            return action.payload;
        case CALL_FINISHED:
            return null;
        case OPERATOR_PHONE_CREATED:
            return {
                ...state,
                phones: [...state.phones, action.payload]
            };
        case OPERATOR_PHONE_UPDATED:
            return {
                ...state,
                phones: state.phones.map(el => {
                    if (el.pk_phone === action.payload.pk_phone) {
                        return action.payload;
                    }

                    return el;
                })
            };
        case OPERATOR_EMAIL_CREATED:
            return {
                ...state,
                emails: [...state.emails, action.payload]
            };
        case OPERATOR_EMAIL_UPDATED:
            return {
                ...state,
                emails: state.emails.map(el => {
                    if (el.pk_email === action.payload.pk_email) {
                        return action.payload;
                    }

                    return el;
                })
            };
        case OPERATOR_HYGIENIZED_DEBTOR:
            return {
                ...state,
                emails: action.payload.emails,
                phones: action.payload.phones
            };
        default:
            return state;
    }
};

export const dialerCall = (state = null, action) => {
    switch (action.type) {
        case DIALER_CALL_UPDATED:
            return action.payload;
        case DIALER_CALL_ENDED:
            return {
                ...state,
                inCall: false
            };
        case CALL_FINISHED:
            return null;
        default:
            return state;
    }
};

// send button in requesr-info
const sendInteraction = (state = null, action) => {
    switch (action.type) {
        case SEND_TEXT_SUCCESS:
            return action.payload;
        case SEND_TEXT_ERROR:
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};
export const creatingDealLoading = (state = false, action) => {
    switch (action.type) {
        case DEAL_CREATE_LOADING:
            return action.payload;
        case CALL_FINISHED:
            return false;
        default:
            return state;
    }
};

export const createdDeals = (state = [], action) => {
    switch (action.type) {
        case DEAL_CREATED:
            return [...state, action.payload];
        case CALL_FINISHED:
            return [];
        default:
            return state;
    }
};

export const loadingDebtActions = (state = false, action) => {
    switch (action.type) {
        case DEBT_ACTIONS_LOADING:
            return action.payload;
        case DEBT_ACTIONS_LOADED:
            return false;
        case CALL_FINISHED:
            return false;
        default:
            return state;
    }
};

export const debtActions = (state = { system: {}, operator: {} }, action) => {
    switch (action.type) {
        case OPERATOR_ACTION_CREATED:
            return {
                system: state.system,
                operator: {
                    ...state.operator,
                    data: [action.payload[0], ...state.operator.data]
                }
            };
        case DEBT_ACTIONS_LOADED:
            return {
                system: action.payload.system
                    ? action.payload.system
                    : state.system,
                operator: action.payload.operator
                    ? action.payload.operator
                    : state.operator
            };
        case DEBT_ACTIONS_CLEAR:
        case CALL_FINISHED:
            return {
                system: {},
                operator: {}
            };
        default:
            return state;
    }
};

const debtorsList = (state = {}, action) => {
    switch (action.type) {
        case OPERATOR_LOAD_DEBTORS_SUCCESS:
            return action.payload;
        case AUTH_LOGOUT:
            return {};
        default:
            return state;
    }
};

const isLoadingDebtorList = (state = false, action) => {
    switch (action.type) {
        case OPERATOR_LOAD_DEBTORS_REQUEST:
            return true;
        case OPERATOR_LOAD_DEBTORS_SUCCESS:
        case OPERATOR_LOAD_DEBTORS_ERROR:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

const debtSimulation = (state = null, action) => {
    switch (action.type) {
        case OPERATOR_LOAD_DEBT_SIMULATION_SUCCESS:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

const operators = (state = null, action) => {
    switch (action.type) {
        case OPERATORS_LOAD_SUCCESS:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

const debtSimulationLoading = (state = false, action) => {
    switch (action.type) {
        case OPERATOR_LOAD_DEBT_SIMULATION_REQUEST:
            return true;
        case OPERATOR_LOAD_DEBT_SIMULATION_SUCCESS:
        case OPERATOR_LOAD_DEBT_SIMULATION_ERROR:
            return false;
        default:
            return state;
    }
};

const dialTimer = (state = null, action) => {
    switch (action.type) {
        case OPERATOR_DIAL_TIMER_CHANGED:
            return action.payload;
        default:
            return state;
    }
};

const actionCreated = (state = false, action) => {
    switch (action.type) {
        case OPERATOR_ACTION_CREATED:
            return true;
        case CALL_FINISHED:
            return false;
        default:
            return state;
    }
};

const requestInformation = (state = null, action) => {
    switch (action.type) {
        case LOAD_REQUEST_SUCCESS:
            return action.payload;
        case LOAD_REQUEST_ERROR:
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

const loadingRequest = (state = false, action) => {
    switch (action.type) {
        case LOAD_REQUEST_REQUEST:
            return true;
        case LOAD_REQUEST_SUCCESS:
        case LOAD_REQUEST_ERROR:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

const voipCampaign = (state = VOIP_CAMPAIGNS.RECEPTIVA, action) => {
    switch (action.type) {
        case SET_VOIP_CAMPAIGN:
            return action.payload;
        default:
            return state;
    }
};

export default combineReducers({
    contact,
    dialerCall,
    creatingDealLoading,
    createdDeals,
    debtActions,
    debtorsList,
    isLoadingDebtorList,
    debtSimulation,
    debtSimulationLoading,
    dialTimer,
    actionCreated,
    operators,
    requestInformation,
    loadingRequest,
    sendInteraction,
    voipCampaign,
});
